import { render, staticRenderFns } from "./PublicProjectHouses.vue?vue&type=template&id=3bed6694&"
import script from "./PublicProjectHouses.vue?vue&type=script&lang=js&"
export * from "./PublicProjectHouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports